module.exports = __webpack_public_path__ + "img/customers.9848724c.svg";